import { useEffect } from 'react';
import { business } from '../data/site';
const TITLE = 'Yamaha & Honda Outboard Dealer & Repowers | Soundside Marine | Edenton, NC';
const DESCRIPTION = 'Soundside Marine Services in Edenton, NC — the area’s only authorized Yamaha and Honda outboard dealer. Repowers, new outboards, certified service and the only hydraulic drive-in test tank in the area.';
export function Seo() {
  useEffect(() => {
    document.title = TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = DESCRIPTION;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: business.name,
      image: business.logo,
      url: 'https://soundsidemarine.com/',
      telephone: '+1-252-482-4363',
      email: business.email,
      address: {
        '@type': 'PostalAddress',
        streetAddress: business.street,
        addressLocality: business.city,
        addressRegion: business.state,
        postalCode: business.zip,
        addressCountry: 'US'
      },
      openingHoursSpecification: [{
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
        opens: '08:00',
        closes: '16:00'
      }, {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Friday',
        opens: '08:00',
        closes: '12:00'
      }]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'soundside-localbusiness';
    script.text = JSON.stringify(schema);
    document.getElementById('soundside-localbusiness')?.remove();
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return null;
}